import { Component } from 'react';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import { ROOT_FONT_SIZE } from 'HubStyleTokens/sizes';
import { EERIE } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const eerieStyle = {
  color: EERIE
};
const pStyle = Object.assign({
  fontSize: ROOT_FONT_SIZE
}, eerieStyle);
const containerStyle = {
  marginTop: '100px'
};
class ConversationMovedToTrash extends Component {
  render() {
    return /*#__PURE__*/_jsxs(UIFlex, {
      style: containerStyle,
      justify: "start",
      align: "center",
      direction: "column",
      children: [/*#__PURE__*/_jsx(UIBox, {
        children: /*#__PURE__*/_jsx(UIIllustration, {
          name: "no-conversations",
          width: "200px"
        })
      }), /*#__PURE__*/_jsx(UIBox, {
        className: "m-top-6 selenium-test-marker-chat-feed-zero-state",
        children: /*#__PURE__*/_jsx("h2", {
          style: eerieStyle,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-ui.conversationMovedToTrash.noLongerHere"
          })
        })
      }), /*#__PURE__*/_jsx(UIBox, {
        children: /*#__PURE__*/_jsx("p", {
          style: pStyle,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-ui.conversationMovedToTrash.movedToTrash"
          })
        })
      }, 1)]
    });
  }
}
ConversationMovedToTrash.displayName = 'ConversationMovedToTrash';
export default ConversationMovedToTrash;